import { render, staticRenderFns } from "./CardAdminComandos.vue?vue&type=template&id=c185efe4&scoped=true"
import script from "./CardAdminComandos.vue?vue&type=script&lang=js"
export * from "./CardAdminComandos.vue?vue&type=script&lang=js"
import style0 from "./CardAdminComandos.vue?vue&type=style&index=0&id=c185efe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c185efe4",
  null
  
)

export default component.exports